module.exports = __webpack_public_path__ + "media/bootstrap-icons/piggy-bank-fill-09d5a8ae.svg";